import React from 'react';
import { Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { UserService } from '../services/user.service';
import { User } from '../models/user';

interface IState {
  users: User[];
  status: string;
  columns: any;
}

export class UsersPage extends React.Component<any, IState> {

  constructor(props: any) {
    super(props);

    this.state = {
      users: new Array<User>(),
      status: "",
      columns: [{
        dataField: 'id',
        text: 'ID',
        headerStyle: () => {
          return { width: '5%' };
        },
        sort: true
      },
      {
        dataField: 'firstName',
        text: 'Ime',
        sort: true,
        filter: textFilter()
      },
      {
        dataField: 'lastName',
        text: 'Prezime',
        sort: true,
        filter: textFilter()
      },
      {
        dataField: 'email',
        text: 'Email',
        sort: true,
        filter: textFilter()
      },
      {
        dataField: 'phone',
        text: 'Telefon',
        sort: true,
        filter: textFilter()
      },
      {
        dataField: 'mentorName',
        text: 'Mentor',
        sort: true,
        filter: textFilter()
      },
      {
        dataField: 'representativeName',
        text: 'Zastupnik',
        sort: true,
        filter: textFilter()
      },
      {
        dataField: 'edit',
        isDummyField: true,
        text: 'Uredi',
        formatter: (cellContent, row) => {
          return (
            <React.Fragment>
              <LinkContainer to={'/user/edit/' + row.id}>
                <Button className="btn-primary">
                  Uredi
                </Button>
              </LinkContainer>
              <br/>
              <LinkContainer to={'/reminder/list/' + row.id}>
                  <Button className="btn-warning mt-10" >
                    Podsjetnici
                  </Button>
              </LinkContainer>
              <br/>
              <LinkContainer to={'/reminder/log/' + row.id}>
                  <Button className="btn-info mt-10" >
                    Dnevnik zapisa
                  </Button>
              </LinkContainer>
            </React.Fragment>
          );
        }
      }]
    };
  }

  componentDidMount() {
    UserService.getAll()
      .then(
        response => {
          this.setState({
            users: response
          });
        },
        error => {
          this.setState({
            status: error.message
          });
        }
      );
  }

  render() {
    return (
      <div>
        <h1 className="page-title">Korisnici</h1>
        <div className="row form-group">
          <div className="col-md-12">
            <LinkContainer to={'/user/edit'}>
              <Button className="btn-primary">
                Unesi novog korisnika
                </Button>
            </LinkContainer>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            {this.state.status &&
              <div className={'alert alert-danger'}>{this.state.status}</div>
            }
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <BootstrapTable
              striped
              hover
              keyField='id'
              data={this.state.users}
              columns={this.state.columns}
              filter={filterFactory()}
              pagination={paginationFactory()} />
          </div>
        </div>
      </div>
    );
  }
}